import { ApiService } from "../api.service";
import { UpdateDates } from "@/models/entities/storage/updateDates.interface";
// import { StorageFilters } from "@/models/entities/storage/storageFilters.interface";
// import { StorageElements } from "@/models/entities/storage/storageElements.interface";
import {
  filterStructure,
  FilterParameters,
  receivedFilterStructure,
} from "@/models/entities/storage/storageInput/storageInput.interface";
const CONTROLLER = "productfilters";

class StorageService extends ApiService {
  getCustomerFilter(codiceCliente: string) {
    const parameters = "?codiceCliente=" + codiceCliente;
    return this.getAll<filterStructure[]>(
      `${CONTROLLER}/categoriaperutente${parameters}`
    );
  }

  getLastModified(category: string, catalogueSourceID: string | number) {
    return this.getAll<UpdateDates>(
      `${CONTROLLER}/lastmodified?categoryID=${category}&catalogueSourceID=${catalogueSourceID}`
    );
  }

  getGenericFilter(
    filterName: string,
    parameters: FilterParameters = null,
    signal: AbortSignal = null
  ) {
    if (parameters == null) {
      return this.getAll<receivedFilterStructure[]>(
        `${CONTROLLER}/${filterName}`,
        {
          signal: signal,
        }
      );
    } else {
      let paramString = "";
      if (parameters.category) {
        paramString += "category=" + parameters.category + "&";
      }
      if (parameters.brand) {
        paramString += "brand=" + encodeURIComponent(parameters.brand) + "&";
      }
      if (parameters.model) {
        paramString += "model=" + encodeURIComponent(parameters.model) + "&";
      }
      if (parameters.fromYear) {
        paramString += "fromYear=" + parameters.fromYear + "&";
      }
      if (parameters.catalogueSourceID) {
        paramString +=
          "catalogueSourceID=" + parameters.catalogueSourceID + "&";
      }
      if (parameters.snowChainID) {
        paramString += "snowChainID=" + parameters.snowChainID + "&";
      }
      if (parameters.tire) {
        paramString += "tire=" + parameters.tire + "&";
      }
      if (parameters.canali) {
        paramString += "canali=" + parameters.canali + "&";
      }
      if (parameters.height) {
        paramString += "height=" + parameters.height + "&";
      }
      if (parameters.diametro) {
        paramString += "diametro=" + parameters.diametro + "&";
      }
      if (parameters.carType) {
        paramString += "carType=" + parameters.carType + "&";
      }
      if (parameters.wheelModel) {
        paramString += "wheelModel=" + parameters.wheelModel + "&";
      }
      if (parameters.finishing) {
        paramString += "finishing=" + parameters.finishing + "&";
      }

      return this.getAll<receivedFilterStructure[]>(
        `${CONTROLLER}/${filterName}?${paramString}`,
        {
          signal: signal,
        }
      );
    }
  }
}

export const storageService = new StorageService();
